module.exports = __webpack_public_path__ + "static/img/module2.b7be4f13.jpg";